import styled from 'styled-components';
import Icon from '../../assets/images/tick-circle-icon.svg';

interface TickIconProps {
  /** Icon fill colour. Defaults to `#000000` */
  fill?: string;
}

const TickIcon = styled.span<TickIconProps>`
  ${({ fill = '#000000' }) => `
        background-color: ${fill};
        display: block;
        mask-image: url("${Icon}");
        mask-position: center center;
        mask-repeat: no-repeat;
        mask-size: 100%;
        position: relative;
        width: 24px;
        height: 24px;
    `}
`;

export default TickIcon;
